

















































import { Folder } from "@/domain/folder";
import { ShareDateTranslator } from "@/infrastructure/folder/translators";
import { FileSizeConverter } from "@/utilities";
import { Component, Mixins, Prop, Emit } from "vue-property-decorator";

@Component
export default class FolderTableSelector extends Mixins() {
  @Prop()
  folders: Folder[];

  toDateTimeString(date: Date): string {
    const dateTranslator = new ShareDateTranslator();
    return dateTranslator.toDateTimeDispString(date);
  }

  toDateString(date: Date): string {
    const dateTranslator = new ShareDateTranslator();
    return dateTranslator.toDateDispString(date);
  }

  toDisplaySize(size: number): string {
    return FileSizeConverter.toString(size);
  }

  toFolderStatusClass(folder: Folder): string {
    return folder.published
      ? "publish"
      : "private";
  }

  toFolderStatus(folder: Folder): string {
    return folder.published
      ? "公開中"
      : "非公開";
  }

  sortFolderStatus(a: Folder, b: Folder): number {
    return (a.published ? 0 : 1) - (b.published ? 0 : 1);
  }

  @Emit()
  selectionChanged(value: Folder): void {}
}
